import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="section-hero">
        <div className="container text-center">
          <div className="fade-in-up">
            <h1  style={{ marginBottom: '1.5rem', fontSize: '3.5rem', color: '#e3efec' }}>
              Transform Your Business with
              <span className="gradient-text"> Innovative SaaS Solutions</span>
            </h1>
            <p style={{
              fontSize: '1.25rem',
              maxWidth: '700px',
              margin: '0 auto 3rem auto',
              color: 'rgba(255, 255, 255, 0.9)',
              lineHeight: 1.7
            }}>
              Empower your organization with scalable, secure, and intelligent software solutions.
              From CRM to custom applications, we deliver technology that drives growth and efficiency.
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/solutions" className="btn btn-accent">
                Explore Solutions
              </Link>
              <Link to="/contact" className="btn btn-outline" style={{ color: 'white', borderColor: 'white' }}>
                Get Started Today
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section" style={{ background: 'var(--gray-50)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Why Choose VissdaTech?</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              We combine cutting-edge technology with deep industry expertise to deliver solutions that make a difference.
            </p>
          </div>

          <div className="grid grid-3">
            {features.map((feature, index) => (
              <div key={index} className="card text-center">
                <div style={{
                  fontSize: '3rem',
                  marginBottom: '1rem',
                  background: 'var(--gradient-accent)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  {feature.icon}
                </div>
                <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>{feature.title}</h3>
                <p style={{ color: 'var(--gray-600)' }}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section">
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Our Core Services</h2>
            <p style={{ fontSize: '1.125rem', maxWidth: '600px', margin: '0 auto', color: 'var(--gray-600)' }}>
              Comprehensive SaaS solutions designed to streamline your operations and accelerate growth.
            </p>
          </div>

          <div className="grid grid-2">
            {services.map((service, index) => (
              <div key={index} className="card" style={{
                background: index % 2 === 0 ? 'var(--white)' : 'var(--gray-50)',
                border: index % 2 === 0 ? '1px solid var(--gray-200)' : 'none'
              }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                  <div style={{
                    fontSize: '2rem',
                    background: 'var(--gradient-primary)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    flexShrink: 0
                  }}>
                    {service.icon}
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1.25rem', marginBottom: '0.75rem', color: 'var(--gray-900)' }}>
                      {service.title}
                    </h3>
                    <p style={{ color: 'var(--gray-600)', marginBottom: '1rem' }}>
                      {service.description}
                    </p>
                    <ul style={{
                      listStyle: 'none',
                      padding: 0,
                      margin: 0,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.5rem'
                    }}>
                      {service.features.map((feat, i) => (
                        <li key={i} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          color: 'var(--gray-600)',
                          fontSize: '0.95rem'
                        }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--primary-green)" strokeWidth="2">
                            <polyline points="20,6 9,17 4,12"></polyline>
                          </svg>
                          {feat}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center" style={{ marginTop: '3rem' }}>
            <Link to="/solutions" className="btn btn-primary">
              View All Solutions
            </Link>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section" style={{ background: 'var(--gradient-primary)', color: 'white' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '3rem' }}>
            <h2 style={{ color: 'white' }}>Trusted by Businesses Worldwide</h2>
            <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '1.125rem' }}>
              Our track record speaks for itself
            </p>
          </div>

          <div className="grid grid-3" style={{ textAlign: 'center' }}>
            {stats.map((stat, index) => (
              <div key={index} style={{ padding: '2rem' }}>
                <div style={{
                  fontSize: '3rem',
                  fontWeight: 'bold',
                  color: '#f1f3f4',
                  marginBottom: '0.5rem'
                }}>
                  {stat.number}
                </div>
                <h4 style={{ color: 'white', fontSize: '1.125rem', marginBottom: '0.5rem' }}>
                  {stat.label}
                </h4>
                <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.95rem' }}>
                  {stat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section">
        <div className="container">
          <div className="card" style={{
            background: 'var(--gradient-hero)',
            color: 'white',
            textAlign: 'center',
            padding: '4rem 2rem',
            border: 'none'
          }}>
            <h2 style={{ color: 'white', fontSize: '2.5rem', marginBottom: '1rem' }}>
              Ready to Transform Your Business?
            </h2>
            <p style={{
              fontSize: '1.25rem',
              marginBottom: '2rem',
              color: 'rgba(255, 255, 255, 0.9)',
              maxWidth: '600px',
              margin: '0 auto 2rem auto'
            }}>
              Join hundreds of companies that have revolutionized their operations with our SaaS solutions.
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn btn-accent">
                Start Your Journey
              </Link>
              <Link to="/about" className="btn btn-outline" style={{ color: 'white', borderColor: 'white' }}>
                Learn More About Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const features = [
  {
    icon: "🚀",
    title: "Scalable Solutions",
    description: "Built to grow with your business, from startup to enterprise scale with seamless performance."
  },
  {
    icon: "🔒",
    title: "Enterprise Security",
    description: "Bank-level security protocols, encrypted data transmission, and compliance with industry standards."
  },
  {
    icon: "⚡",
    title: "Lightning Fast",
    description: "Optimized performance with global CDN, ensuring quick load times and responsive user experience."
  },
  {
    icon: "🎯",
    title: "Customizable",
    description: "Tailor every aspect to match your business processes and branding requirements."
  },
  {
    icon: "📊",
    title: "Analytics & Insights",
    description: "Powerful reporting tools and real-time analytics to drive data-informed decisions."
  },
  {
    icon: "🤝",
    title: "24/7 Support",
    description: "Dedicated support team available around the clock to ensure your success."
  }
];

const services = [
  {
    icon: "�",
    title: "Custom Solutions",
    description: "Tailored software solutions designed specifically for your unique business requirements and processes.",
    features: ["Bespoke Development", "Custom Architecture", "Scalable Design", "Industry-Specific Features"]
  },
  {
    icon: "🤖",
    title: "AI Workflows & Automation",
    description: "Intelligent automation powered by AI to streamline your business processes and increase efficiency.",
    features: ["Process Automation", "AI-Powered Analytics", "Workflow Optimization", "Smart Decision Making"]
  },
  {
    icon: "�",
    title: "Trading Applications to Automate Investments",
    description: "Advanced trading platforms and automated investment solutions for portfolio management and trading strategies.",
    features: ["Automated Trading", "Portfolio Management", "Risk Analysis", "Real-time Market Data"]
  }
];

const stats = [
  {
    number: "500+",
    label: "Happy Clients",
    description: "Businesses transformed with our solutions"
  },
  {
    number: "99.9%",
    label: "Uptime Guarantee",
    description: "Reliable service you can count on"
  },
  {
    number: "24/7",
    label: "Support Available",
    description: "Round-the-clock assistance when needed"
  }
];

export default Home;